import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  startDate: Yup.string(),
  finishDate: Yup.string(),
});

export default validationSchema;
